import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, Center, Spinner, Stack, Text } from "@chakra-ui/react";
import { AUTH_PROVIDERS, useAuthProvider } from "../Authentication/AuthProviderSwitch";
import { OrganizationSwitcher } from "../ClerkAuthentication/clerkReact";
import { hasClientAccess } from "../Authentication/roleAccess";

const ClientProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, provider, orgId, orgRole, has } = useAuthProvider();
  const location = useLocation();

  if (isLoading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/client/login" state={{ from: location }} replace />;
  }

  if (provider !== AUTH_PROVIDERS.CLERK) {
    return <Navigate to="/login" replace />;
  }

  if (!orgId) {
    return (
      <Center minH="100vh" px={6}>
        <Box bg="white" borderWidth="1px" borderRadius="lg" p={6} maxW="480px" w="full" boxShadow="sm">
          <Stack spacing={3}>
            <Text fontSize="lg" fontWeight="semibold">
              Select your client organization
            </Text>
            <Text color="gray.600">
              Choose the organization where your role is Client to continue to the client portal.
            </Text>
            <OrganizationSwitcher />
          </Stack>
        </Box>
      </Center>
    );
  }

  if (!hasClientAccess({ orgRole, has })) {
    return (
      <Center minH="100vh" px={6}>
        <Box bg="white" borderWidth="1px" borderRadius="lg" p={6} maxW="560px" w="full" boxShadow="sm">
          <Stack spacing={3}>
            <Text fontSize="lg" fontWeight="semibold">
              Client portal access required
            </Text>
            <Text color="gray.600">
              Your active Clerk organization must grant the Client role before you can manage subscriptions,
              purchases, integrations, and support.
            </Text>
            <OrganizationSwitcher />
          </Stack>
        </Box>
      </Center>
    );
  }

  return children;
};

export default ClientProtectedRoute;
